import React, { Component } from "react";
import GoogleMapReact from "google-map-react";
import LogoAmbassadrice from "../img/ambassadrice.png";
import LogoAmbassadriceHover from "../img/ambassadrice-hover.png";

class MarkerAmbassadrice extends Component {
  state = {};
  render() {
    return (
      <div
        onClick={() => this.props.displayMarkerInfo(this.props.id)}
        style={{ transform: "translate(-50%, -50%)", position: "relative" }}
      >
        <div>
          <img
            className={
              (this.props.displayHover &&
                this.props.id === this.props.hoveredAmbassadrice) ||
              this.props.$hover
                ? "hover-marker-ambassadrice animated bounce infinite"
                : ""
            }
            src={
              (this.props.displayHover &&
                this.props.id === this.props.hoveredAmbassadrice) ||
              this.props.$hover
                ? LogoAmbassadriceHover
                : LogoAmbassadrice
            }
            alt=""
          />
        </div>
      </div>
    );
  }
}

class MapAmbassadrice extends Component {
  state = {};

  static defaultProps = {
    center: {
      lat: 45.402360945627876,
      lng: 2.629857699349145
    },
    zoom: 3
  };

  render() {
    return (
      <div className="content">
        <div style={{ height: "642px", width: "100%" }}>
          <GoogleMapReact
            bootstrapURLKeys={{
              key: "AIzaSyAuCkGwRBWkPuGkYnDi6rDiuqxqN-x53U0"
            }}
            defaultCenter={this.props.center}
            defaultZoom={this.props.zoom}
          >
            {this.props.data
              .filter(m => m.acf.ambassadrice_carte)
              .map(m => (
                <MarkerAmbassadrice
                  key={m.id}
                  lat={m.acf.ambassadrice_carte.lat}
                  lng={m.acf.ambassadrice_carte.lng}
                  id={m.id}
                  displayMarkerInfo={this.props.displayMarkerInfo}
                  hoveredAmbassadrice={this.props.hoveredAmbassadrice}
                  displayHover={this.props.displayHover}
                />
              ))}
          </GoogleMapReact>
        </div>
      </div>
    );
  }
}

export default MapAmbassadrice;



// WEBPACK FOOTER //
// ./src/Components/MapAmbassadrice.jsx